import {
  Companion_getInstance23zmguv2nlvyd as Companion_getInstance,
  UserEventType3ayinm14vltts as UserEventType,
  EventType2bd9gu34l4i61 as EventType,
} from './shared.mjs';
import { NothingSerializer3oixyyf77l4xt as NothingSerializer } from '../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/builtins/BuiltinSerializers.mjs';
import {
  properties1qnxlk10mmfrs as properties,
  get_serializableAnnotations132wwdaanmitj as get_serializableAnnotations,
  SerializableProperty3ugfzrmvjw266 as SerializableProperty,
} from '../../../../lightning-server-shared/com/lightningkite/serialization/SerializableProperty.mjs';
import { lazy2hsh8ze7j6ikd as lazy } from '../../../../kotlin-kotlin-stdlib/kotlin/kotlin.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { GeneratedSerializer1f7t7hssdd2ws as GeneratedSerializer } from '../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/PluginHelperInterfaces.mjs';
import {
  isInterface3d6p8outrmvmk as isInterface,
  isComparableviyv6ctzm76u as isComparable,
} from '../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import { KSerializerzf77vz1967fq as KSerializer } from '../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/KSerializer.mjs';
import { KProperty1ca4yb4wlo496 as KProperty1 } from '../../../../kotlin-kotlin-stdlib/kotlin/reflect/KPropertyJs.mjs';
import { getPropertyCallableRef3hckxc0xueiaj as getPropertyCallableRef } from '../../../../kotlin-kotlin-stdlib/kotlin/js/reflectRuntime.mjs';
import { protoOf180f3jzyo7rfj as protoOf } from '../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function prepareUserEventTypeFields() {
  var tmp = Companion_getInstance().c8k(NothingSerializer());
  properties(tmp, prepareUserEventTypeFields$lambda);
}
function UserEventType_user$name$delegate$lambda() {
  return Companion_getInstance().c8k(NothingSerializer()).az().v11(0);
}
function UserEventType_user$_get_name_$ref_n2uqs2() {
  return (p0) => p0.i20();
}
function UserEventType_user$_get_serializer_$ref_v3w9zp() {
  return (p0) => p0.h2j();
}
function UserEventType_user$_get_annotations_$ref_dz33eh() {
  return (p0) => p0.bz();
}
var UserEventType_userClass;
function UserEventType_user() {
  if (UserEventType_userClass === VOID) {
    class $ {
      constructor(uID) {
        var tmp = this;
        tmp.p8p_1 = lazy(UserEventType_user$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.q8p_1 = lazy(() => {
          var tmp = Companion_getInstance().c8k(uID);
          var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).r1b()[0];
          return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
        });
        var tmp_1 = this;
        tmp_1.r8p_1 = lazy(() => Companion_getInstance().c8k(uID).az().x11(0));
      }
      i20() {
        var tmp0 = this.p8p_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, UserEventType_user$_get_name_$ref_n2uqs2(), null);
        return tmp0.f2();
      }
      s8p(receiver) {
        return receiver.t8p_1;
      }
      k2j(receiver) {
        return this.s8p(receiver instanceof UserEventType() ? receiver : THROW_CCE());
      }
      v8p(receiver, value) {
        return receiver.w8p(value);
      }
      n2j(receiver, value) {
        var tmp = receiver instanceof UserEventType() ? receiver : THROW_CCE();
        return this.v8p(tmp, (!(value == null) ? isComparable(value) : false) ? value : THROW_CCE());
      }
      h2j() {
        var tmp0 = this.q8p_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, UserEventType_user$_get_serializer_$ref_v3w9zp(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.r8p_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, UserEventType_user$_get_annotations_$ref_dz33eh(), null);
        return tmp0.f2();
      }
      hashCode() {
        return -1388994850;
      }
      equals(other) {
        return other instanceof UserEventType_user();
      }
    }
    protoOf($).o2j = get_serializableAnnotations;
    initMetadataForClass($, 'UserEventType_user', VOID, VOID, [SerializableProperty()]);
    UserEventType_userClass = $;
  }
  return UserEventType_userClass;
}
function UserEventType_type$name$delegate$lambda() {
  return Companion_getInstance().c8k(NothingSerializer()).az().v11(1);
}
function UserEventType_type$_get_name_$ref_9xu9qb() {
  return (p0) => p0.i20();
}
function UserEventType_type$_get_serializer_$ref_lxtt98() {
  return (p0) => p0.h2j();
}
function UserEventType_type$_get_annotations_$ref_oqymnc() {
  return (p0) => p0.bz();
}
var UserEventType_typeClass;
function UserEventType_type() {
  if (UserEventType_typeClass === VOID) {
    class $ {
      constructor(uID) {
        var tmp = this;
        tmp.x8p_1 = lazy(UserEventType_type$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.y8p_1 = lazy(() => {
          var tmp = Companion_getInstance().c8k(uID);
          var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).r1b()[1];
          return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
        });
        var tmp_1 = this;
        tmp_1.z8p_1 = lazy(() => Companion_getInstance().c8k(uID).az().x11(1));
      }
      i20() {
        var tmp0 = this.x8p_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, UserEventType_type$_get_name_$ref_9xu9qb(), null);
        return tmp0.f2();
      }
      s8p(receiver) {
        return receiver.u8p_1;
      }
      k2j(receiver) {
        return this.s8p(receiver instanceof UserEventType() ? receiver : THROW_CCE());
      }
      a8q(receiver, value) {
        return receiver.w8p(VOID, value);
      }
      n2j(receiver, value) {
        var tmp = receiver instanceof UserEventType() ? receiver : THROW_CCE();
        return this.a8q(tmp, value instanceof EventType() ? value : THROW_CCE());
      }
      h2j() {
        var tmp0 = this.y8p_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, UserEventType_type$_get_serializer_$ref_lxtt98(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.z8p_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, UserEventType_type$_get_annotations_$ref_oqymnc(), null);
        return tmp0.f2();
      }
      hashCode() {
        return -1389729457;
      }
      equals(other) {
        return other instanceof UserEventType_type();
      }
    }
    protoOf($).o2j = get_serializableAnnotations;
    initMetadataForClass($, 'UserEventType_type', VOID, VOID, [SerializableProperty()]);
    UserEventType_typeClass = $;
  }
  return UserEventType_typeClass;
}
function prepareUserEventTypeFields$lambda(args) {
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  return [new (UserEventType_user())(args[0]), new (UserEventType_type())(args[0])];
}
//region block: exports
export {
  UserEventType_user as UserEventType_userv06183wfmbun,
  prepareUserEventTypeFields as prepareUserEventTypeFields2fkfy6hlfz70o,
};
//endregion

//# sourceMappingURL=UserEventTypeFields.mjs.map
